import React, { useState, useEffect, useCallback } from 'react';
import { adminService } from '../services/api';
import { ADMIN_OPS_REFRESH } from '../constants/adminEvents';
import './TestimoniosAdmin.css';

const TestimoniosAdmin = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [counts, setCounts] = useState({ pendientes: 0, aprobados: 0, rechazados: 0, total: 0 });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('todos');

  const fetchTestimonials = useCallback(async () => {
    try {
      setLoading(true);
      const res = await adminService.getTestimonials(filter);
      const data = res?.testimonials ?? [];
      setTestimonials(data);
      setCounts(res?.counts ?? { pendientes: 0, aprobados: 0, rechazados: 0 });
      setCurrentIndex(0);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    fetchTestimonials();
  }, [fetchTestimonials]);

  const updateTestimonialStatus = async (testimonialId, newStatus) => {
    try {
      await adminService.updateTestimonialStatus(testimonialId, newStatus);
      window.dispatchEvent(new Event(ADMIN_OPS_REFRESH));
      setTestimonials(prev => 
        prev.map(t => t.id === testimonialId ? { ...t, status: newStatus } : t)
      );
      if (currentIndex < testimonials.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        setCurrentIndex(0);
        fetchTestimonials();
      }
    } catch (error) {
      console.error('Error updating testimonial:', error);
      alert('Error al actualizar el testimonio');
    }
  };

  const handleApprove = () => {
    if (displayTestimonials[currentIndex]) {
      updateTestimonialStatus(displayTestimonials[currentIndex].id, 'aprobado');
    }
  };

  const handleReject = () => {
    if (displayTestimonials[currentIndex]) {
      updateTestimonialStatus(displayTestimonials[currentIndex].id, 'rechazado');
    }
  };

  if (loading) {
    return (
      <div className="testimonios-admin-container">
        <div className="loading-spinner"></div>
        <p>Cargando testimonios...</p>
      </div>
    );
  }

  const displayTestimonials = testimonials;

  if (displayTestimonials.length === 0) {
    return (
      <div className="testimonios-admin-container">
        <h2>Moderación de Testimonios</h2>

        <div className="filter-buttons">
          <button 
            className={`filter-btn ${filter === 'pendiente' ? 'active' : ''}`} 
            onClick={() => setFilter('pendiente')}
          >
            Pendientes ({counts.pendientes})
          </button>
          <button 
            className={`filter-btn ${filter === 'aprobado' ? 'active' : ''}`} 
            onClick={() => setFilter('aprobado')}
          >
            Aprobados ({counts.aprobados})
          </button>
          <button 
            className={`filter-btn ${filter === 'rechazado' ? 'active' : ''}`} 
            onClick={() => setFilter('rechazado')}
          >
            Rechazados ({counts.rechazados})
          </button>
          <button 
            className={`filter-btn ${filter === 'todos' ? 'active' : ''}`} 
            onClick={() => setFilter('todos')}
          >
            Todos ({counts.total})
          </button>
        </div>

        <div className="no-testimonials">
          <p>No hay testimonios {filter === 'todos' ? '' : filter} para mostrar.</p>
        </div>
      </div>
    );
  }

  const currentTestimonial = displayTestimonials[currentIndex];

  return (
    <div className="testimonios-admin-container">
      <h2>Moderación de Testimonios</h2>

      <div className="filter-buttons">
        <button 
          className={`filter-btn ${filter === 'pendiente' ? 'active' : ''}`} 
          onClick={() => setFilter('pendiente')}
        >
          Pendientes ({counts.pendientes})
        </button>
        <button 
          className={`filter-btn ${filter === 'aprobado' ? 'active' : ''}`} 
          onClick={() => setFilter('aprobado')}
        >
          Aprobados ({counts.aprobados})
        </button>
        <button 
          className={`filter-btn ${filter === 'rechazado' ? 'active' : ''}`} 
          onClick={() => setFilter('rechazado')}
        >
          Rechazados ({counts.rechazados})
        </button>
        <button 
          className={`filter-btn ${filter === 'todos' ? 'active' : ''}`} 
          onClick={() => setFilter('todos')}
        >
          Todos ({counts.total})
        </button>
      </div>

      {currentTestimonial && (
        <div className="testimonial-card-wrapper">
          <div className="testimonial-card">
            <div className="card-header">
              <h3>{currentTestimonial.name}</h3>
              <span className={`status-badge ${currentTestimonial.status}`}>
                {currentTestimonial.status}
              </span>
            </div>
            <p className="card-category">Categoría: {currentTestimonial.category}</p>
            <div className="card-rating">
              {Array.from({ length: 5 }, (_, i) => (
                <i key={i} className={`fas fa-star ${i < currentTestimonial.rating ? 'filled' : ''}`}></i>
              ))}
            </div>
            <p className="card-message">"{currentTestimonial.message}"</p>
            <p className="card-service">Servicio: {currentTestimonial.service}</p>
            <p className="card-date">Fecha: {new Date(currentTestimonial.date || currentTestimonial.created_at || '').toLocaleDateString()}</p>
          </div>

          <div className="moderation-controls">
            <button className="reject-btn" onClick={handleReject}>
              <i className="fas fa-times"></i> Rechazar
            </button>
            <button className="approve-btn" onClick={handleApprove}>
              <i className="fas fa-check"></i> Aprobar
            </button>
          </div>

          <div className="progress-indicator">
            Testimonio {currentIndex + 1} de {displayTestimonials.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default TestimoniosAdmin;